import { useEffect, useState } from "react";
import { api, type GiftsView } from "../api";
import { Overlay, Skeleton, Spinner } from "../ui";

interface Props {
  onClose: () => void;
  showToast: (t: string) => void;
}

/** Магазин подарков: тратим монеты, заработанные по реферальной программе. */
export function Shop({ onClose, showToast }: Props) {
  const [data, setData] = useState<GiftsView | null>(null);
  const [failed, setFailed] = useState(false);
  const [claimingId, setClaimingId] = useState<string | null>(null);

  const load = () => {
    setFailed(false);
    api.gifts().then(
      (r) => setData(r),
      () => setFailed(true),
    );
  };

  useEffect(load, []);

  const claim = async (giftId: string, cost: number) => {
    if (!data || data.coins < cost || claimingId) return;
    setClaimingId(giftId);
    try {
      await api.claimGift(giftId);
      showToast("Награда получена!");
      load();
    } catch {
      showToast("Не удалось получить награду. Попробуйте ещё раз.");
    } finally {
      setClaimingId(null);
    }
  };

  return (
    <Overlay title="Магазин подарков" onClose={onClose} tone="light">
      <div className="sheetbody">
        {!data && !failed && <Skeleton rows={4} tall />}
        {failed && <p className="sub">Не удалось загрузить. Попробуйте ещё раз.</p>}
        {data && (
          <>
            <div className="card">
              <h3>Твои монеты</h3>
              <p className="sub">
                <b style={{ fontSize: 22 }}>{data.coins}</b>
              </p>
            </div>

            {data.items.length === 0 ? (
              <div className="card">
                <p className="sub">Пока нет доступных наград — загляните позже.</p>
              </div>
            ) : (
              data.items.map((g) => {
                const canAfford = data.coins >= g.costCoins;
                const disabled = !canAfford || !g.claimable || claimingId === g.id;
                return (
                  <div className="card" key={g.id}>
                    <div className="row" style={{ alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 22 }}>{g.icon}</span>
                      <h3 style={{ margin: 0 }}>{g.title}</h3>
                    </div>
                    {g.description && <p className="sub">{g.description}</p>}
                    <div className="row" style={{ alignItems: "center", marginTop: 8 }}>
                      <span className="sub">
                        {g.claimedByMe > 0 && `Уже получено: ${g.claimedByMe}. `}
                        Стоимость: <b>{g.costCoins}</b> монет
                      </span>
                      <button className="outline" disabled={disabled} onClick={() => void claim(g.id, g.costCoins)}>
                        {claimingId === g.id ? <Spinner /> : !g.claimable ? "Лимит исчерпан" : canAfford ? "Получить" : "Не хватает монет"}
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </>
        )}
      </div>
    </Overlay>
  );
}
